<template>
  <iframe :src="webUrl+'/admin/platform/link'"></iframe>
</template>

<script>
export default {
  name: "link",
  setup(){
    return {
      "webUrl" : process.env.VUE_APP_DAILIAO_WEB_URL
    }
  }
}
</script>

<style scoped>

</style>